import axiosLib from 'axios'

export const axios = axiosLib.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // eslint-disable-next-line
    console.log(error)

    const { error_code: errorCode, selected_property_id: selectedPropertyId } =
      error.response.data

    if (errorCode === 'PROPERTY_CHANGED') {
      const sessionPropertyId = sessionStorage.getItem('propertyId')

      // prevent reload hell
      if (sessionPropertyId === selectedPropertyId) {
        // clear session and local to force logout
        localStorage.removeItem('token')
        localStorage.removeItem('property')
        localStorage.removeItem('subscriptionStart')
        localStorage.removeItem('subscriptionEnd')
        localStorage.removeItem('propertyId')

        return window.location.reload()
      }

      // replace session storage propertyId with the local storage set from a different tab
      sessionStorage.setItem('propertyId', selectedPropertyId)
      return window.location.reload()
    }

    Promise.reject(error)
  }
)

axios.interceptors.request.use(
  (request) => {
    request.headers['property-id'] = sessionStorage.getItem('propertyId')

    return request
  },
  (error) => {
    // eslint-disable-next-line
    console.log(error)

    Promise.reject(error)
  }
)
